/**
 * Skeleton primitive — loading state placeholder.
 *
 * Uses `animate-pulse` for the default shimmer effect.
 * Respects `prefers-reduced-motion` via `motion-reduce:animate-none`.
 * Follows button.tsx pattern: forwardRef + cn() + type exports.
 */
import { forwardRef } from 'react';
import type { HTMLAttributes, ReactElement } from 'react';
import { cn } from '@/lib/utils';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {}

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  function Skeleton({ className, ...props }, ref): ReactElement {
    return (
      <div
        ref={ref}
        className={cn(
          'animate-pulse rounded-md bg-muted/30',
          'motion-reduce:animate-none',
          className,
        )}
        {...props}
      />
    );
  },
);
